// recentMembersSection/container.js
import React from 'react';
import RecentMembersSectionView from './view';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

// Configure dayjs
dayjs.extend(relativeTime);

const RecentMembersSection = (props) => {
  // Enhanced container logic
  const handleMemberClick = (member) => {
    // You can add analytics or logging here
    
    // Call the original handler
    if (props.onMemberClick) {
      props.onMemberClick(member);
    }
  };

  const handleViewAll = () => {
    // You can add analytics or logging here
    
    // Call the original handler
    if (props.onViewAll) {
      props.onViewAll();
    }
  };

  return (
    <RecentMembersSectionView 
      {...props}
      onMemberClick={handleMemberClick}
      onViewAll={handleViewAll}
    />
  );
};

export default RecentMembersSection;